import { useGetCustomerServiceReps } from '~/hooks/apis/loyalty/useCustomerServiceReps';

export function useConciergeRepLabel(repId: string | null): string | null {
  const { data } = useGetCustomerServiceReps({ page: 1, pageSize: 50 });
  if (!repId) {
    return null;
  }

  const rep = data?.result.reps.find((entry) => entry.id === repId);
  return rep ? `${rep.firstName} ${rep.lastName}` : null;
}
